import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, type Language } from "@/i18n";
import { cn } from "@/lib/utils";

/** Compact English / हिन्दी switch; the choice is remembered on this device and sent to the API. */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage as Language;
  return (
    <div role="radiogroup" aria-label={t("language.label")} className={cn("inline-flex items-center rounded-xl border bg-muted/60 p-1", className)}>
      <Languages className="mx-1.5 h-4 w-4 text-muted-foreground" aria-hidden />
      {LANGUAGES.map(({ code, short, name }) => (
        <button
          key={code}
          type="button"
          role="radio"
          lang={code}
          aria-checked={current === code}
          aria-label={name}
          title={name}
          onClick={() => void i18n.changeLanguage(code)}
          className={cn(
            "h-7 min-w-8 rounded-lg px-2 text-xs font-semibold text-muted-foreground transition-all hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2",
            current === code && "bg-card text-foreground shadow-soft",
          )}
        >
          {short}
        </button>
      ))}
    </div>
  );
}
